module.exports = __webpack_public_path__ + "img/图片4.23ddd95f.jpg";